(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deeplay-collection-size-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dp-image-categories')) {
    customElements.define('dp-image-categories', class extends HTMLElement {
      connectedCallback() {
        // A frame also allows all children to parse when inserted by the editor.
        this.initFrame = requestAnimationFrame(() => this.init());
      }
      init() {
        this.viewport = this.querySelector('.dpic-viewport');
        this.list = this.querySelector('.dpic-list');
        this.bar = this.querySelector('.dpic-progress');
        if (!this.viewport || !this.list || !this.bar || this.events) return;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.rtl = getComputedStyle(this.viewport).direction === 'rtl';
        this.sync = () => {
          const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
          const overflow = maximum > 1;
          this.bar.hidden = !overflow;
          this.viewport.tabIndex = overflow ? 0 : -1;
          if (!overflow) return;
          const visible = this.viewport.clientWidth / this.viewport.scrollWidth;
          this.bar.style.setProperty('--dp-thumb', `${Math.max(20, this.bar.clientWidth * visible)}px`);
          const position = Math.min(maximum, Math.abs(this.viewport.scrollLeft));
          this.bar.value = String(Math.round(position / maximum * 1000));
          this.bar.setAttribute('aria-valuetext', `${Math.round(position / maximum * 100)}% scrolled`);
        };
        this.viewport.addEventListener('scroll', this.sync, { passive: true, signal });
        this.bar.addEventListener('input', () => {
          this.setAttribute('data-seeking', '');
          const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
          this.viewport.scrollLeft = maximum * Number(this.bar.value) / 1000 * (this.rtl ? -1 : 1);
          this.sync();
        }, { signal });
        this.bar.addEventListener('change', () => this.removeAttribute('data-seeking'), { signal });
        this.bar.addEventListener('blur', () => this.removeAttribute('data-seeking'), { signal });
        window.addEventListener('resize', this.sync, { passive: true, signal });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.sync);
          this.observer.observe(this.viewport);
          this.observer.observe(this.list);
          this.observer.observe(this.bar);
        }
        this.setAttribute('data-enhanced', '');
        this.sync();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        if (this.events) this.events.abort();
        if (this.observer) this.observer.disconnect();
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
